import React, { Component } from 'react'
import Link from 'gatsby-link'
import MediaQuery from 'react-responsive'
import Img from 'gatsby-image'

//Components
import SelectLanguage from './SelectLanguage'

//Menus
import FooterNav from '../menus/FooterNav'
import PostFooter from '../menus/PostFooter'

const Footer = props => {
  return (
    <React.Fragment>
      <footer className="container">
        <div className="logo">
          <Img
            title="Budget"
            alt="Budget Nicaragua"
            sizes={props.footerLogo.sizes}
          />
        </div>
        <FooterNav langs={props.langs} />
      </footer>
      <PostFooter langs={props.langs} />
    </React.Fragment>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js